module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_07.jpg?v=c21a0312";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_07.jpg
 ** module id = 64
 ** module chunks = 1 2
 **/